import React from 'react';

const PurchaseInfo = ({ text }) => (
    <h5 className='c15 op70 fs1rem my0-5rem tac fw500' style={{ letterSpacing: '0.5px' }}>
        {text}
    </h5>
);

export default PurchaseInfo; 